import { IIconProps } from '~/types';
const BsdFlag = (props: IIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={1200} height={600} viewBox="0 0 6 3" {...props}>
    <path fill="#00778b" d="M0 0h6v3H0z" />
    <path fill="#ffc72c" d="M1 1h5v1H1z" />
    <path d="M2.598 1.5 0 3V0z" />
  </svg>
);
export default BsdFlag;
